// AppCard?.tsx
import React from 'react';
import {
    Card,
    CardContent,
    CardActions,
    CardMedia,
    Typography,
    Button,
    Chip,
    Box,
    styled
} from '@mui/material';
import theme from 'themes/theme';
import { ReactComponent as Crown } from 'assets/nav_icons/crown-svgrepo-com.svg';
import { Primary } from 'ui-components/Buttons';

const StyledCard = styled(Card)(({ theme }) => ({
    height: '100%',
    display: 'grid',
    alignItems: "start",
    alignContent: "space-between",
    gap: "0rem",
    borderRadius: 20,
    padding: "0.5rem",
    boxShadow: 'none',
    maxWidth: "22.375rem", // 358 + padding = 375
    // boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: `1px solid ${theme.palette.customColors?.b50}`,
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
        // transform: 'translateY(-4px)',
        // boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
    },
}));

const CardHeader = styled(Box)(({ theme }) => ({
    position: 'relative',
    padding: theme.spacing(2, 2, 0, 2),
}));

const BadgeChip = styled(Chip)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontSize: '0.75rem',
    height: 24,
    width: 50,
    borderRadius: 4,
}));

const IllustrationBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // height: 160,
    minWidth: 150,
    aspectRatio: 3 / 2,
    margin: "1rem 0rem",
    marginInline: "auto",
    overflow: "hidden",
    width: "calc(100% - 2rem)",
    borderRadius: 8
}));

const ContentSection = styled(CardContent)(({ theme }) => ({
    flexGrow: 1,
    paddingTop: 0,
    paddingBottom: theme.spacing(1),
}));

const ActionSection = styled(CardActions)(({ theme }) => ({
    padding: theme.spacing(0, 2, 2, 2),
    justifyContent: 'center',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5, 4),
    fontSize: '0.95rem',
}));

// `imageSx` is additive and defaults to {}, so existing callers (ResourcesTab) render
// exactly as before; only callers that pass it restyle the illustration.
const AppCard = ({ card, onClick, actionSectionStyle = {}, button_text, cardSx = {}, imageSx = {} }) => {
    const handleCardClick = () => {
        if (onClick) {
            onClick(card);
        }
    };

    console.log(card);

    return (
        <StyledCard sx={{
            margin: "auto",
            ...cardSx
        }}>
            <Box sx={{
                display: 'grid',
                gap: "0.5rem"
            }}>
                <CardHeader sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography
                        variant="h6"
                        component="h2"
                        fontWeight="bold"
                        sx={{
                            fontSize: 'clamp(1rem, 1.25vw, 1.25rem)',
                            lineHeight: 1.3,
                            mb: 0,
                            pr: card?.badge ? 6 : 0
                        }}
                    >
                        {card?.title}
                    </Typography>
                    {card?.is_unlocked !== null && card?.is_unlocked !== undefined && card?.is_unlocked && (
                        <Crown fill="orange" width={20} height={20} />
                    )}
                </CardHeader>

                <IllustrationBox sx={{ ...imageSx }}>

                    {card?.image ?
                        <CardMedia
                            component="img"
                            image={card?.image}
                            alt={card?.title}
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        /> : <Box sx={{ bgcolor: "gray", width: "100%", height: "100%" }}> </Box>}
                </IllustrationBox>

                <ContentSection sx={{ paddingBottom: "0.5rem !important" }}>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            fontSize: '0.9rem',
                            lineHeight: 1.5,
                            textAlign: 'left',
                            mb: 1
                        }}
                    >
                        {card?.description}
                    </Typography>
                </ContentSection>
            </Box>

            <ActionSection sx={{ ...actionSectionStyle }}>
                <Primary
                    color="primary"
                    disabled={card?.is_coming_soon}
                    sx={{
                        padding: ".7rem 1.25rem",
                        ':disabled': {
                            color: "white !important",
                            background: theme.palette.customColors.b300 + "BA"
                        }
                    }}
                    onClick={handleCardClick}
                    fullWidth
                >
                    {button_text ? button_text: card?.button_text}
                </Primary>
            </ActionSection>
        </StyledCard >
    );
};

export default AppCard;
